import {Pipe, PipeTransform}    from '@angular/core';
import {Helper}                 from "../utils/helper";
import {FormuleEnum}            from "@shared/enums/formule.enum";
import {PriceFormuleParameters} from "../../components/main/oav-phase-b/preconisation/priceFormuleParameters";
import {EXTENSION}   from "./mntFormatted.pipe";
import { CONSTANTS } from "@shared/constants/constants";

@Pipe({standalone:true,name: 'ShowMontantTarificationPhaseBPipe'})
export class ShowMontantTarificationPhaseBPipe implements PipeTransform {
    transform(prices: PriceFormuleParameters[], formule: FormuleEnum, key: string): string {
        let  lib = '';
        const elementPrice = prices.find(c => c.formuleEnum === formule);
        if (!!elementPrice) {
            const mnt          = elementPrice.price[key];
            let valueFormatted = `${Helper.currencyFormatter(mnt || 0, 'EUR', '1.2-2')}`;
            let extension      = `/ ${EXTENSION[elementPrice.periodicite.key] || CONSTANTS.DEFAULT}`;
            lib = `${valueFormatted} ${extension}`;
        }
        return lib;
    }
}
